import CONFIG from '@/config';
import { isAtLeastManager } from '@/models/common';
import AuthUserStore from '@/common/utils/AuthUser';
import { formDataInstance } from '../axios';

export const mapItemPricesFromEdges = itemPrices => {
  return itemPrices?.edges?.map(item => ({
    ...item.node,
    pricingTier: item.node?.pricingTier?.id
  }));
};

export const mapItemPurchaseCategory = category => {
  return category?.id;
};

export const printPrettyPrice = amount => {
  const newAmount: Float32Array = amount > 0 ? amount.toFixed(2) : 0.0;
  return newAmount;
};

export const getMaintainanceStatus = async () => {
  return fetch(CONFIG.MAINTENANCE_API).then(response => ({
    status: !!parseInt(response.headers.get('pow-maintenance-mode') || '0'),
    response
  }));
};

// there should be no need to translate to or from API generated ids
export const Id2Gql = (s, id) => {
  if (!id) {
    return null;
  }
  const joined = s + ':' + id.toString();
  return btoa(joined);
};

export const Gql2Id = g => {
  if (!g) {
    return null;
  }
  const s = atob(g);
  const vals = s.split(':');
  return vals[1];
};

export function isManager() {
  const roles = AuthUserStore.getRoles();
  return isAtLeastManager(roles);
}

// Have the backend merge
export async function callRest(endpoint, postVars, onSuccess, onError) {
  // Construct our full endpiont
  const url = CONFIG.API + endpoint;

  // JSON format and auth
  const restHeaders = {
    'Content-Type': 'application/json',
    Authorization: 'JWT ' + (localStorage.getItem('RES_AUTH_TOKEN') || '')
  };
  // Call to the backend REST API and handle success and failures using the proimises
  await formDataInstance
    .post(url, postVars, { headers: restHeaders })
    .then(res => {
      // Success
      onSuccess(res);
    })
    .catch(e => {
      // Server had an 400 error
      console.error(e);
      const msg = e?.response?.data?.error;
      onError(msg);
    })
    .catch(e => {
      // Other error
      onError(e);
    });
}

export function prettyDate(date) {
  if (!date) {
    return '';
  }
  return `${date.slice(5, 7)}/${date.slice(8, 10)}/${date.slice(0, 4)}`;
}

export function capitalizeAll(str) {
  return str.replace(/\b\w/g, char => char.toUpperCase());
}

export function displayGender(str) {
  return str === 'None' ? 'Undisclosed' : str;
}

export const removeUndefined = <T extends object>(obj: T): Partial<T> =>
  Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined)
  ) as Partial<T>;

export const twoDecimalPlaces = (
  num: string,
  setValue: React.Dispatch<React.SetStateAction<string>>
): string => {
  const val = num.match(/^(\d*\.{0,1}\d{0,2}$)/);
  if (val) {
    setValue(val[0]);
  }
  return val ? val[0] : '';
};
